<ul class="navbar-nav me-auto mb-2 mb-lg-0" [ngClass]="customClass ? customClass + '-nav' : ''">
	<!-- Why Power Kiosk -->
	<li class="nav-item">
		<a class="nav-link" [routerLink]="['/why-power-kiosk']" (click)="closeCanvas()" id="headerWhyPK">Why Power Kiosk</a>
	</li>
	<!-- Who We Serve -->
	<li ngbDropdown #partnerDropdown="ngbDropdown" class="nav-item dropdown-mega">
		<a ngbDropdownToggle href="javascript:void(0)" class="nav-link" role="button"> Who We Serve </a>
		<div ngbDropdownMenu>
			<div class="container-fluid mega-nav-content">
				<div class="row maxwidth mx-auto">
					<!-- Navigation Menu -->
					<div class="col-12 col-xl-8 col-xxxl-7">
						<div class="row">
							<div class="col-12 col-xl-6 order-0">
								<div class="card nav-link-card">
									<div class="card-body">
										<p class="mega-nav-link-header">Energy Advisors</p>
										<p class="mega-nav-sub-copy">Deliver an exceptional, client-first energy experience while driving growth.</p>
										<a [routerLink]="['/partners', 'energy-advisor']" (click)="closeCanvas()" class="stretched-link" id="headerEnergyAdvisor"></a>
									</div>
								</div>
							</div>
							<div class="col-12 col-xl-6 order-1 order-lg-2">
								<div class="card nav-link-card">
									<div class="card-body">
										<p class="mega-nav-link-header">Commercial &amp; Enterprises</p>
										<p class="mega-nav-sub-copy">Centralize procurement, billing, and energy strategy for clarity and control.</p>
										<a
											[routerLink]="['/partners', 'commercial-and-enterprise']"
											(click)="closeCanvas()"
											class="stretched-link"
											id="headerCommercialAndEnterprise"></a>
									</div>
								</div>
							</div>
							<div class="col-12 col-xl-6 order-2 order-lg-1">
								<div class="card nav-link-card">
									<div class="card-body">
										<p class="mega-nav-link-header">Energy Suppliers</p>
										<p class="mega-nav-sub-copy">Boost revenue with AI-powered pricing insights and market analytics.</p>
										<a [routerLink]="['/partners', 'energy-supplier']" (click)="closeCanvas()" class="stretched-link" id="headerEnergySupplier"></a>
									</div>
								</div>
							</div>
							<div class="col-12 col-xl-6 order-3">
								<div class="card nav-link-card">
									<div class="card-body">
										<p class="mega-nav-link-header">Referral Partners</p>
										<p class="mega-nav-sub-copy">Earn new revenue by referring commercial customers with end-to-end, tech-driven procurement.</p>
										<a [routerLink]="['/partners', 'referral-partner']" (click)="closeCanvas()" class="stretched-link" id="headerReferralPartner"></a>
									</div>
								</div>
							</div>
						</div>
					</div>
					<!-- Image in Navigation -->
					<div class="col-12 col-xl-4 offset-xxxl-1 my-4 my-xl-0">
						<div class="card side-card partners">
							<div class="card-body d-flex align-items-end justify-content-start mx-xxl-4">
								<div class="row">
									<div class="col-11 col-xxl-9">
										<h5>A partnership that delivers.</h5>
										<p>Discover how Power Kiosk can meet your unique energy procurement needs.</p>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</li>
	<!-- Products -->
	<li ngbDropdown #productsDropdown="ngbDropdown" class="nav-item dropdown-mega">
		<a ngbDropdownToggle href="javascript:void(0)" class="nav-link" role="button"> Products </a>
		<div ngbDropdownMenu>
			<div class="container-fluid mega-nav-content">
				<div class="row maxwidth mx-auto">
					<!-- Navigation Menu -->
					<div class="col-12 col-xl-8 col-xxxl-7">
						<div class="row">
							<div class="col-12 col-xl-6">
								<div class="card nav-link-card">
									<div class="card-body">
										<p class="mega-nav-link-header">Energy Marketplace</p>
										<p class="mega-nav-sub-copy">
											Compare real-time supplier rates, secure custom offers, and stay ahead with proactive contract and service alerts.
										</p>
										<a [routerLink]="['/products']" (click)="closeCanvas()" class="stretched-link" id="headerEnergyMarketplace"></a>
									</div>
								</div>
							</div>
							<div class="col-12 col-xl-6">
								<div class="card nav-link-card">
									<div class="card-body">
										<p class="mega-nav-link-header">Energy Portals</p>
										<p class="mega-nav-sub-copy">
											Branded portals for advisors, enterprises, and residential consumers centralizing data, contracts, and sustainability insights.
										</p>
										<a
											[routerLink]="['/products']"
											[fragment]="'energy-portals'"
											(click)="closeCanvas()"
											class="stretched-link"
											id="headerEnergyPortals"></a>
									</div>
								</div>
							</div>
							<div class="col-12 col-xl-6">
								<div class="card nav-link-card">
									<div class="card-body">
										<p class="mega-nav-link-header">AI Agents</p>
										<p class="mega-nav-sub-copy">
											Automate workflows with AI, from pricing recommendations and utility bill reading to smart enrollment, reducing errors, and
											speeding execution.
										</p>
										<a [routerLink]="['/products']" [fragment]="'ai-agents'" (click)="closeCanvas()" class="stretched-link" id="headerAiAgents"></a>
									</div>
								</div>
							</div>
							<div class="col-12 col-xl-6">
								<div class="card nav-link-card">
									<div class="card-body">
										<p class="mega-nav-link-header">Industry Training</p>
										<p class="mega-nav-sub-copy">
											Gain the knowledge to grow with Advisor Academy, your hub for energy market insights, sales enablement, and best practices.
										</p>
										<a
											[routerLink]="['/products']"
											[fragment]="'industry-training'"
											(click)="closeCanvas()"
											class="stretched-link"
											id="headerIndustryTraining"></a>
									</div>
								</div>
							</div>
						</div>
					</div>
					<!-- Image in Navigation -->
					<div class="col-12 col-xl-4 offset-xxxl-1 my-4 my-xl-0">
						<div class="card side-card products">
							<div class="card-body d-flex align-items-end justify-content-start mx-xxl-4">
								<div class="row">
									<div class="col-11 col-xxl-9">
										<h5>Solutions that scale.</h5>
										<p>Explore the products designed to simplify procurement, empower advisors, and unlock smarter energy decisions.</p>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</li>
	<!-- Resources -->
	<li ngbDropdown #resourcesDropdown="ngbDropdown" class="nav-item dropdown-mega">
		<a ngbDropdownToggle href="javascript:void(0)" class="nav-link" role="button"> Resources </a>
		<div ngbDropdownMenu>
			<div class="container-fluid mega-nav-content">
				<div class="row maxwidth mx-auto">
					<!-- Navigation Menu -->
					<div class="col-12 col-xl-8 col-xxxl-7">
						<div class="row">
							<div class="col-12 col-xl-6">
								<div class="card nav-link-card">
									<div class="card-body">
										<p class="mega-nav-link-header">Advisor Academy</p>
										<p class="mega-nav-sub-copy">
											Level up your practice with training, tools, and best practices to grow as an Energy Advisor professional.
										</p>
										<a
											[routerLink]="['/products']"
											[fragment]="'industry-training'"
											(click)="closeCanvas()"
											class="stretched-link"
											id="headerAdvisorAcademy"></a>
									</div>
								</div>
							</div>
							<div class="col-12 col-xl-6">
								<div class="card nav-link-card">
									<div class="card-body">
										<p class="mega-nav-link-header">Blog</p>
										<p class="mega-nav-sub-copy">Stay ahead with insights on energy markets, strategy, and lessons from industry leaders.</p>
										<a [routerLink]="['/resources', 'blog']" (click)="closeCanvas()" class="stretched-link" id="headerBlog"></a>
									</div>
								</div>
							</div>
							<div class="col-12 col-xl-6 d-none">
								<div class="card nav-link-card">
									<div class="card-body">
										<p class="mega-nav-link-header">Customer Stories</p>
										<p class="mega-nav-sub-copy">See how businesses like yours are driving growth, savings, and sustainability with Power Kiosk.</p>
										<a
											[routerLink]="['/resources', 'customer-stories']"
											(click)="closeCanvas()"
											class="stretched-link"
											id="headerCustomerStories"></a>
									</div>
								</div>
							</div>
							<div class="col-12 col-xl-6">
								<div class="card nav-link-card">
									<div class="card-body">
										<p class="mega-nav-link-header">Deregulated Energy Map</p>
										<p class="mega-nav-sub-copy">Explore where deregulation creates opportunity and unlocks market access at a glance.</p>
										<a
											[routerLink]="['/resources', 'deregulated-energy-map']"
											(click)="closeCanvas()"
											class="stretched-link"
											id="headerDeregulatedEnergyMap"></a>
									</div>
								</div>
							</div>
						</div>
					</div>
					<!-- Image in Navigation -->
					<div class="col-12 col-xl-4 offset-xxxl-1 my-4 my-xl-0">
						<div class="card side-card resources">
							<div class="card-body d-flex align-items-end justify-content-start mx-xxl-4">
								<div class="row">
									<div class="col-11 col-xxl-9">
										<h5>Resources that empower.</h5>
										<p>Access insights, tools, and stories designed to help you succeed in every stage of energy management.</p>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</li>
	<!-- Company -->
	<li ngbDropdown #companyDropdown="ngbDropdown" class="nav-item dropdown-mega">
		<a ngbDropdownToggle href="javascript:void(0)" class="nav-link" role="button"> Company </a>
		<div ngbDropdownMenu>
			<div class="container-fluid mega-nav-content">
				<div class="row maxwidth mx-auto">
					<!-- Navigation Menu -->
					<div class="col-12 col-xl-8 col-xxxl-7">
						<div class="row">
							<div class="col-12 col-xl-6">
								<div class="card nav-link-card">
									<div class="card-body">
										<p class="mega-nav-link-header">About</p>
										<p class="mega-nav-sub-copy">Discover our story, mission, values, and the leaders shaping how we help customers succeed.</p>
										<a [routerLink]="['/company', 'about']" (click)="closeCanvas()" class="stretched-link" id="headerAbout"></a>
									</div>
								</div>
							</div>
							<div class="col-12 col-xl-6">
								<div class="card nav-link-card">
									<div class="card-body">
										<p class="mega-nav-link-header">Careers</p>
										<p class="mega-nav-sub-copy">Join a growing team transforming the way businesses manage energy.</p>
										<a [routerLink]="['/company', 'careers']" (click)="closeCanvas()" class="stretched-link" id="headerCommercialAndEnterprise"></a>
									</div>
								</div>
							</div>
							<div class="col-12 col-xl-6">
								<div class="card nav-link-card">
									<div class="card-body">
										<p class="mega-nav-link-header">Contact Us</p>
										<p class="mega-nav-sub-copy">Get in touch with our team to start a conversation about your energy needs.</p>
										<a [routerLink]="['/company', 'contact-us']" (click)="closeCanvas()" class="stretched-link" id="headerContactUs"></a>
									</div>
								</div>
							</div>
						</div>
					</div>
					<!-- Image in Navigation -->
					<div class="col-12 col-xl-4 offset-xxxl-1 my-4 my-xl-0">
						<div class="card side-card company">
							<div class="card-body d-flex align-items-end justify-content-start mx-xxl-4">
								<div class="row">
									<div class="col-11 col-xxl-9">
										<h5>The people behind the platform.</h5>
										<p>Learn more about who we are, what drives us, and how to connect with our team.</p>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</li>
</ul>
<ul class="navbar-nav mb-2 mb-lg-0" [ngClass]="customClass ? customClass + '-nav' : ''">
	<li class="nav-item">
		<a class="nav-link" [attr.href]="dashboardLogin" target="_blank" id="headerMarketplaceLogin">Login</a>
	</li>
	<li class="nav-item pt-2" id="mainNavigationDemo">
		<a [href]="scheduleDemoHref" class="btn btn-dark schedule-demo" id="scheduleDemoHeader"
			>Schedule Discovery Call <span class="ending-icon"><fa-icon [icon]="['fas', 'arrow-right']"></fa-icon></span
		></a>
	</li>
</ul>
